import { Badge } from './primitives/Badge'
import styles from './StatusBadge.module.css'
import { formatStatusLabel } from './statusLabels'

const WHITESPACE_RUN_PATTERN = /\s+/g

const statusMap = {
  active: 'success', healthy: 'success', completed: 'success', approved: 'success', connected: 'success', automated: 'success',
  failed: 'error', error: 'error', rejected: 'error', disconnected: 'error', unhealthy: 'error', cancelled: 'error',
  pending: 'warning', pending_approval: 'warning', waiting: 'warning', scheduled: 'warning',
  processing: 'info', running: 'info', in_progress: 'info', approval: 'info', conditional: 'info',
  inactive: 'default', disabled: 'default', draft: 'default',
}

const tones = { success: 'success', error: 'danger', warning: 'warning', info: 'info', default: 'neutral' }

export function StatusBadge({ status = 'default', type, children, auto = false, animated = false, size = 'medium', className = '' }) {
  const resolvedStatus = type || status
  const lookupKey = auto && children ? children.toString().toLowerCase().replace(WHITESPACE_RUN_PATTERN, '_') : null
  const finalStatus = lookupKey ? statusMap[lookupKey] || 'default' : resolvedStatus
  const label = auto && typeof children === 'string' ? formatStatusLabel(children) : children
  return (
    <Badge tone={tones[finalStatus] || 'neutral'} compact={size === 'small'} className={`${styles.badge} status-${finalStatus} status-${size} ${animated ? styles.animated : ''} ${className}`.trim()}>
      {animated ? <span className={styles.pulse} aria-hidden="true" /> : null}{label}
    </Badge>
  )
}
